<pa-textarea ngDefaultControl
    [name]="name"
    [id]="id"
    [formControl]="control"
    [placeholder]="schema.placeholder"
    [help]="schema.description"
    [isReadOnly]="schema.readOnly">{{ schema.title }}</pa-textarea>
